module.exports = __webpack_public_path__ + "static/media/game-report-icon.e27bf057.svg";